import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

const SUFFIXES = ['th', 'st', 'nd', 'rd', ''];

@Pipe({
  name: 'ordinalDate',
  standalone: false,
})
@Injectable()
export class OrdinalDatePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(date: any): string {
    if (!date || !(date instanceof Date)) {
      return date;
    }

    return `${this.datePipe.transform(date, 'MMMM')} ${this.getOrdinalDay(date.getDate())} ${this.datePipe.transform(date, 'yyyy')}`;
  }

  private getOrdinalDay(day: number): string {
    let index;

    if (day <= 0) {
      index = 4;
    } else if ((day > 3 && day < 21) || (day % 10 > 3)) {
      index = 0;
    } else {
      index = day % 10;
    }

    return `${day}${SUFFIXES[index]}`;
  }
}
